import { Typography } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import { DomainsList } from './DomainsList';
import { DomainsContext } from './DomainsContext';
import { GenericEntityProperties } from '../entity/shared/types';
import { useTranslation } from '../../i18n/useTranslation';

const PageContainer = styled.div`
    padding-top: 20px;
`;

const PageHeaderContainer = styled.div`
    && {
        padding-left: 24px;
    }
`;

const PageTitle = styled(Typography.Title)`
    && {
        margin-bottom: 12px;
    }
`;

const ListContainer = styled.div``;

export const ManageDomainsPage = () => {
    const { t } = useTranslation();
    const [entityData, setEntityData] = useState<GenericEntityProperties | null>(null);
    const [parentDomainsToUpdate, setParentDomainsToUpdate] = useState<string[]>([]);

    return (
        <DomainsContext.Provider value={{ entityData, setEntityData, parentDomainsToUpdate, setParentDomainsToUpdate }}>
            <PageContainer>
                <PageHeaderContainer>
                    <PageTitle level={3}>{t('Domains')}</PageTitle>
                    <Typography.Paragraph type="secondary">{t('MANAGE_DOMAINS_DESCRIPTION')}</Typography.Paragraph>
                </PageHeaderContainer>
                <ListContainer>
                    <DomainsList />
                </ListContainer>
            </PageContainer>
        </DomainsContext.Provider>
    );
};
